// Meta Pixel utility — initializes the Facebook Pixel and exposes helpers to fire events.

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

const PIXEL_ID = '1270442961879164'
let initialized = false

export const initMetaPixel = () => {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  // Standard Meta Pixel base code (adapted to safely inject into the DOM
  // even when there are no pre-existing <script> tags in the document).
  const f: any = window
  if (!f.fbq) {
    const n: any = (f.fbq = function () {
      // eslint-disable-next-line prefer-rest-params
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    const parent = document.head || document.body || document.documentElement
    parent.appendChild(script)
  }

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}

export const trackEvent = (
  eventName: string,
  params?: Record<string, unknown>,
) => {
  if (typeof window === 'undefined' || !window.fbq) return
  if (params) {
    window.fbq('track', eventName, params)
  } else {
    window.fbq('track', eventName)
  }
}

export const trackAddToCart = () => {
  trackEvent('AddToCart', {
    content_name: 'Amarre Ancestral de 3 Noches',
    content_category: 'Manual Digital',
    content_ids: ['43225681821757'],
    content_type: 'product',
    value: 7.0,
    currency: 'USD',
  })
}
